import {
  FETCH_UNASSIGNED_AREAS_START,
  FETCH_UNASSIGNED_AREAS_SUCCESS,
  FETCH_UNASSIGNED_AREAS_FAIL,
  FETCH_ASSIGNED_AREAS_START,
  FETCH_ASSIGNED_AREAS_SUCCESS,
  FETCH_ASSIGNED_AREAS_FAIL,
  FETCH_AREAS_START,
  FETCH_AREAS_SUCCESS,
  FETCH_AREAS_FAILED,
  CREATE_AREA_START,
  CREATE_AREA_SUCCESS,
  CREATE_AREA_FAIL,
  DELETE_AREA_START,
  DELETE_AREA_SUCCESS,
  DELETE_AREA_FAIL,
  UPDATE_AREA_START,
  UPDATE_AREA_SUCCESS,
  UPDATE_AREA_FAIL,
  REMOVE_BROKER_START,
  REMOVE_BROKER_SUCCESS,
  REMOVE_BROKER_FAIL,
  UPDATE_BROKER_SUCCESS,
} from "../store/types";

import {//
  cloud_function_server_url,
} from "config";


// Fetch all unassigned areas
export const fetchAllUnAssignedAreas = () => (dispatch) => (firebase) => {
  const { unAssignedAreasRef } = firebase;

  dispatch({ type: FETCH_UNASSIGNED_AREAS_START });

  unAssignedAreasRef.on("value", (snapshot) => {
    try {
      const areas = snapshot.val() ? Object.values(snapshot.val()) : [];
      dispatch({
        type: FETCH_UNASSIGNED_AREAS_SUCCESS,
        payload: areas,
      });
    } catch (error) {
      console.error("Error fetching unassigned areas:", error);
      dispatch({
        type: FETCH_UNASSIGNED_AREAS_FAIL,
        payload: error.message,
      });
    }
  });
};

// Fetch all assigned areas
export const fetchAllAssignedAreas = () => (dispatch) => (firebase) => {
  const { AssignedAreasRef } = firebase;

  dispatch({ type: FETCH_ASSIGNED_AREAS_START });

  AssignedAreasRef.on("value", (snapshot) => {
    try {
      const areas = snapshot.val() ? Object.values(snapshot.val()) : [];
      dispatch({
        type: FETCH_ASSIGNED_AREAS_SUCCESS,
        payload: areas,
      });
    } catch (error) {
      console.error("Error fetching assigned areas:", error);
      dispatch({
        type: FETCH_ASSIGNED_AREAS_FAIL,
        payload: error.message,
      });
    }
  });
};

//fetch all areas
export const fetchAllAreas = () => (dispatch) => (firebase) => {
  const { AreasRef } = firebase;

  dispatch({ type: FETCH_AREAS_START });

  AreasRef.on("value", (snapshot) => {
    try {
      const areas = snapshot.val() ? Object.values(snapshot.val()) : [];
      dispatch({
        type: FETCH_AREAS_SUCCESS,
        payload: areas,
      });
    } catch (error) {
      console.error("Error fetching areas:", error);
      dispatch({
        type: FETCH_AREAS_FAILED,
        payload: error.message,
      });
    }
  });
};

//remove broker from area
export const removeBrokerFromArea = (broker, areaData) => (dispatch) => async (firebase) => {
  const { UpdateAreaRef, singleUserAreasRef, SingleAreaRef, usersRef, singleUserRef } = firebase;

  const areaId = areaData.areaId;
  const areaLocation = areaData.Location;
  const shareBrokers = areaData.shareBrokers;
  const brokerAreas = broker.Areas;

  try {
    console.log(`in action`);
    dispatch({
      type: REMOVE_BROKER_START,
      payload: null,
    });
    if (areaData) {

      if (areaId === "") {
        dispatch({
          type: REMOVE_BROKER_FAIL,
          payload: "Error: This area has no brokers assigned to it",
        });
        return { success: false, message: "Error: This area has no brokers assigned to it" };
      }
    }

    let matchedEntry = {}

    //removing broker from area
    try {
      console.log("Removing broker from Area:", broker);

      usersRef.on("value", (snapshot) => {
        if (snapshot.val()) {
          const data = snapshot.val();

          if (!data) return;

          matchedEntry = Object.entries(data || {}).find(
            ([key, value]) => value.email === broker.email
          );
          console.log("Matched broker key:", matchedEntry[0]);

          if (matchedEntry) {
            console.log("Data from matchedEntry:", matchedEntry[0], matchedEntry[1]);
            return UpdateAreaRef(areaId).child(matchedEntry[0]).remove();
          } else {
            console.log("Value not found.");
            dispatch({
              type: REMOVE_BROKER_FAIL,
              payload: "Error: This area has no brokers assigned to it",
            });
          }
        }
      })
    } catch (error) {
      dispatch({
        type: REMOVE_BROKER_FAIL,
        payload: "Error: This area has no brokers assigned to it",
      });
      console.error("Failed to remove broker from area:", error);
    }

    //remove area from broker
    try {
      console.log("Removing Area from broker:", areaId);

      singleUserAreasRef(matchedEntry[0]).once('value')
        .then(async snapshot => {
          const data = snapshot.val();
          if (!data) return;
          const entryToDelete = Object.entries(data).find(
            ([key, value]) => value === areaData.areaName
          );

          if (entryToDelete) {
            const [matchedKey, matchedValue] = entryToDelete;
            console.log("Matched broker key:", matchedKey);
            console.log("Matched broker value:", matchedValue);
            singleUserAreasRef(matchedEntry[0]).child(matchedKey).remove();
            try {
              const userSnapshot = await singleUserRef(matchedEntry[0]).once('value');

              console.log(`userSnapshot: ${JSON.stringify(userSnapshot)}`)

              dispatch({
                type: UPDATE_BROKER_SUCCESS,
                payload: userSnapshot.val(),
              });
            } catch (error) {
              console.log(`Was unable to provide singleUserAreasRef snapshot`)
            }
          } else {
            console.log("Value not found.");
            dispatch({
              type: REMOVE_BROKER_FAIL,
              payload: "Error: This area has no brokers assigned to it",
            });
          }
        })
        .then(() => {
          console.log("Entry removed from user.");
        })
        .catch(error => {
          console.error("Error while removing area from user:", error);
          dispatch({
            type: REMOVE_BROKER_FAIL,
            payload: "Error: This area has no brokers assigned to it",
          });
        });
    } catch (error) {
      console.error("Failed to remove area from user:", error);
      dispatch({
        type: REMOVE_BROKER_FAIL,
        payload: "Error: This area has no brokers assigned to it",
      });
    }

    dispatch({
      type: REMOVE_BROKER_SUCCESS,
      payload: null,
    });

    return { success: true, message: "Broker removed!" };

  } catch (error) {
    console.error("Error removing broker from area:", error);

    dispatch({
      type: REMOVE_BROKER_FAIL,
      payload: error.message,
    });
    return { success: false, message: error.message };
  }
};

//update area
export const updateArea = (areaData) => (dispatch) => async (firebase) => {
  const { SingleAreaRef, singleUserAreasRef, singleUserRef } = firebase;

  console.log(`In updateArea action`);

  const updateData = {
    areaName: areaData.areaName,
    areaId: areaData.areaId,
    p24: areaData.p24,
    pp: areaData.pp,
    selectedBranchName: areaData.selectedBranchName,
    shareBrokers: areaData?.shareBrokers ? areaData?.shareBrokers : null,
  }
  const userAreaUpdateData = {
    Location: areaData.areaName,
  }

  const areaId = areaData.areaId;

  try {
    dispatch({
      type: UPDATE_AREA_START,
      payload: null,
    });
    if (areaData) {

      if (areaId === "" || areaId === null) {
        dispatch({
          type: UPDATE_AREA_FAIL,
          payload: "Error: Update is missing some fields",
        });
        return { success: false, message: "Error: Update is missing an areaId" };
      }
    }

    try {
      await SingleAreaRef(areaId).update(updateData);
      const snapshot = await SingleAreaRef(areaId).once('value');
      console.log(`Area updated successfully. ${updateData}`);

      try {
        let matchedBrokersKeys = Object.keys(areaData.shareBrokers);

        for (let index = 0; index < matchedBrokersKeys.length; index++) {
          const element = matchedBrokersKeys[index];

          await singleUserAreasRef(element).child(areaId).set(areaData.areaName);

          let userSnapshot = await singleUserRef(element).once("value");

          if (userSnapshot) {
            try {
              dispatch({
                type: UPDATE_BROKER_SUCCESS,
                payload: userSnapshot.val(),
              });
            } catch (error) {
              console.log(`Could not dispatch update broker success message`)
            }
          }
        }
      } catch (error) {
        console.log(`Error while updating the linked brokers area details: ${error}`)
      }

      console.log(`Area snapshot: ${JSON.stringify(snapshot.val())}`)
      dispatch({
        type: UPDATE_AREA_SUCCESS,
        payload: snapshot.val(),
      });

    } catch (error) {
      console.error('Error updating Area:', error);
    }

    return { success: true, message: "Broker added!" };

  } catch (error) {
    console.error("Error adding broker to area:", error);

    dispatch({
      type: UPDATE_AREA_FAIL,
      payload: error.message,
    });
    return { success: false, message: error.message };
  }
};

//update area brokers
export const updateAreaBroker = (areaData) => (dispatch) => async (firebase) => {
  const { UpdateAreaRef, singleUserAreasRef, singleUserRef } = firebase;

  const areaId = areaData.areaId;
  const shareBrokers = areaData.shareBrokers;

  try {
    dispatch({
      type: UPDATE_AREA_START,
      payload: null,
    });
    if (areaData) {

      if (areaId === "" || shareBrokers.length === 0) {
        dispatch({
          type: UPDATE_AREA_FAIL,
          payload: "Error: Update is missing some fields",
        });
        return { success: false, message: "Error: Update is missing some fields" };
      }
    }

    try {

      let areaIdName = {    //contains the areaId as the key and location as the value
        [areaId]: areaData.areaName,
      };

      for (let index = 0; index < shareBrokers.length; index++) {
        let element = {
          [shareBrokers[index]]: shareBrokers[index],
        };

        console.log("Element to update:", element, typeof element);
        await UpdateAreaRef(areaId).update(element);
        const snapshot = await UpdateAreaRef(areaId).once('value');
        console.log('shareBroker pushed successfully.');

        try {
          console.log("Element to update 2:", areaIdName, typeof areaIdName);
          await singleUserAreasRef(shareBrokers[index]).update(areaIdName);
          const userSnapshot = await singleUserRef(shareBrokers[index]).once('value');
          console.log('Area pushed to the user successfully.');

          dispatch({
            type: UPDATE_BROKER_SUCCESS,
            payload: userSnapshot.val(),
          });
        } catch (error) {
          console.error('Error pushing Area to the user:', error);
        }

        dispatch({
          type: UPDATE_AREA_SUCCESS,
          payload: snapshot.val(),
        });
      }

    } catch (error) {
      console.error('Error pushing Area:', error);
    }

    return { success: true, message: "Broker added!" };

  } catch (error) {
    console.error("Error adding broker to area:", error);

    dispatch({
      type: UPDATE_AREA_FAIL,
      payload: error.message,
    });
    return { success: false, message: error.message };
  }
};

// Add a new area
export const addArea = (areaData) => (dispatch) => async (firebase) => {
  const { AreaRef, singleUserAreasRef, SingleAreaRef, singleUserRef } = firebase;

  let areaId = "";

  try {
    dispatch({
      type: CREATE_AREA_START,
      payload: null,
    });
    if (areaData) {

      let areaName = areaData.areaName;
      let selectedBrokers = areaData.shareBrokers;

      if (selectedBrokers.length > 0) {
        selectedBrokers = Object.fromEntries(
          Object.entries(areaData.shareBrokers).map(([key, value]) => [value, value])
        );
        console.log(`selectedBrokres after normalisation: ${JSON.stringify(selectedBrokers)}`)
        areaData.shareBrokers = selectedBrokers;
      }

      if (areaName === "") {
        dispatch({
          type: CREATE_AREA_FAIL,
          payload: "Error: Area name not provided",
        });
        return { success: false, message: "Error: Area name not provided" };
      }
    }

    try {
      const snapshot = await AreaRef.push(areaData);
      areaId = snapshot.key;
      console.log('Area pushed successfully. Key:', snapshot.key);

      await SingleAreaRef(areaId).child("areaId").set(areaId);

      if (areaData.shareBrokers) {
        console.log(`in shareBrokers condition: ${JSON.stringify(areaData.shareBrokers)}`);
        const brokerKeys = Object.keys(areaData.shareBrokers);

        for (let index = 0; index < brokerKeys.length; index++) {
          console.log(`In loop`)
          const element = brokerKeys[index];

          try {
            console.log(`Broker id to add area into: ${element}`)
            await singleUserAreasRef(element).child(areaId).set(areaData.areaName);
            console.log('Area pushed to the user successfully.');

            try {
              let userSnapshot = await singleUserRef(element).once("value");
              console.log(`userSnapshot in addArea: ${JSON.stringify(userSnapshot)}`)
              if (userSnapshot) {
                dispatch({
                  type: UPDATE_BROKER_SUCCESS,
                  payload: userSnapshot.val(),
                });
              }
            } catch (error) {
              console.log(`Error while getting userSnapshot in addArea`)
            }

          } catch (error) {
            console.error('Error pushing Area to the user:', error);
          }
        }
      }

      dispatch({
        type: CREATE_AREA_SUCCESS,
        payload: snapshot,
      });

    } catch (error) {
      console.error('Error pushing Area:', error);
    }
    return { success: true, message: "Area was created!" };

  } catch (error) {
    console.error("Error adding area:", error);

    dispatch({
      type: CREATE_AREA_FAIL,
      payload: error.message,
    });
    return { success: false, message: error.message };
  }
};

// Delete an area
export const deleteArea = (areaData) => (dispatch) => async (firebase) => {
  const { SingleAreaRef, singleUserAreasRef } = firebase;

  dispatch({ type: DELETE_AREA_START });

  const areaId = areaData.areaId;
  const shareBrokers = areaData.shareBrokers;

  if (!areaId) {
    console.error("Error: No area ID provided");
    dispatch({
      type: DELETE_AREA_FAIL,
      payload: "Error: No area ID provided",
    });
    return;
  }

  try {
    if (shareBrokers) {
      const brokerValues = Object.values(shareBrokers);

      for (let index = 0; index < brokerValues.length; index++) {
        const element = brokerValues[index];
        console.log(`element in deleteArea: ${element}`)

        try {
          await singleUserAreasRef(element).child(areaId).remove();
          console.log('Area removed from the user successfully.');
        } catch (error) {
          dispatch({
            type: DELETE_AREA_FAIL,
            payload: "Error: Error while removing area form user",
          });
          return;
        }
      }
    }

    try {
      await SingleAreaRef(areaId).remove();
      console.log('Area removed successfully.');
    } catch (error) {
      dispatch({
        type: DELETE_AREA_FAIL,
        payload: "Error: Error while removing area form user",
      });
      return;
    }

    dispatch({
      type: DELETE_AREA_SUCCESS,
      payload: areaId,
    });
  } catch (error) {
    console.error("Error deleting area:", error);

    dispatch({
      type: DELETE_AREA_FAIL,
      payload: error.message,
    });
  }
};

// Update an area
// export const updateArea = (areaData) => (dispatch) => async (firebase) => {
//   dispatch({ type: UPDATE_AREA_START });

//   if (!areaData || !areaData.areaId) {
//     console.error("Error: No area data or ID provided");
//     dispatch({
//       type: UPDATE_AREA_FAIL,
//       payload: "Error: No area data or ID provided",
//     });
//     return;
//   }

//   const myHeaders = new Headers();
//   myHeaders.append("Content-Type", "application/json");

//   const requestOptions = {
//     method: "POST",
//     headers: myHeaders,
//     body: JSON.stringify(areaData),
//     redirect: "follow",
//   };

//   try {
//     const response = await fetch(
//       `${cloud_function_server_url}/updateArea`,
//       requestOptions
//     );

//     if (!response.ok) {
//       const errorMessage = await response.text();
//       dispatch({
//         type: UPDATE_AREA_FAIL,
//         payload: `HTTP error! Status: ${response.status}, message: ${errorMessage}`,
//       });
//       throw new Error(`HTTP error! Status: ${response.status}, message: ${errorMessage}`);
//     }

//     const result = await response.json();
//     console.log("Area updated successfully:", result);

//     dispatch({
//       type: UPDATE_AREA_SUCCESS,
//       payload: result,
//     });
//   } catch (error) {
//     console.error("Error updating area:", error);

//     dispatch({
//       type: UPDATE_AREA_FAIL,
//       payload: error.message,
//     });
//   }
// };
